import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

// Global Components
import EveryoneButtonLink from 'components/EveryoneButtonLink';
// @ts-ignore
import EventSchemaHasInstructionsGate from 'components/EventSchemaHasInstructionsGate';
import RoleButtonLink from 'components/RoleButtonLink';
import RoleTableRowLink from 'components/RoleTableRowLink';
// @ts-ignore
import TableActions from 'components/TableActions';

// Child Components
// @ts-ignore
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER,
    FIELD_STAFF,
    SUPERVISOR
} from 'components/RoleGate/constants';
// @ts-ignore
import DocumentSetEventEntityHierarchy from '../../../../../../components/DocumentSetEventEntityHierarchy';
// @ts-ignore
import DocumentSetEventEntityName from '../../../../../../components/DocumentSetEventEntityName';
// @ts-ignore
import DocumentSetEventSchemaName from '../../../../../../components/DocumentSetEventSchemaName';
// @ts-ignore
import DocumentSetAssignedUsersList from '../../../../../../components/DocumentSetAssignedUsersList';
// @ts-ignore
import DocumentSetCreatedAt from '../../../../../../components/DocumentSetCreatedAt';
// @ts-ignore
import DocumentSetEventEndDate from '../../../../../../components/DocumentSetEventEndDate';
// @ts-ignore
import DocumentSetEventEntityDefaultVarietyName from '../../../../../../components/DocumentSetEventEntityDefaultVarietyName';
// @ts-ignore
import DocumentSetEventGroupName from '../../../../../../components/DocumentSetEventGroupName';
// @ts-ignore
import DocumentSetEventStartDate from '../../../../../../components/DocumentSetEventStartDate';
// @ts-ignore
import DocumentSetProgressBadge from '../../../../../../components/DocumentSetProgressBadge';

interface OwnProps {
    documentSetId: number;
}

interface ConnectedProps {
    eventId?: number;
}

type Props = OwnProps & ConnectedProps;

export class DocumentSetsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { documentSetId, eventId } = this.props;
        if (!documentSetId) {
            return null;
        }
        return (
            <RoleTableRowLink
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                to={`/organization/jobs/${documentSetId}`}
            >
                <Table.Cell>
                    <DocumentSetCreatedAt documentSetId={documentSetId} />
                </Table.Cell>
                <Table.Cell>
                    <DocumentSetEventSchemaName documentSetId={documentSetId} />
                </Table.Cell>
                <Table.Cell>
                    <DocumentSetEventEntityHierarchy
                        documentSetId={documentSetId}
                    />
                </Table.Cell>
                <Table.Cell>
                    <DocumentSetEventEntityName documentSetId={documentSetId} />
                </Table.Cell>
                <Table.Cell>
                    <DocumentSetEventEntityDefaultVarietyName
                        documentSetId={documentSetId}
                    />
                </Table.Cell>
                <Table.Cell>
                    <DocumentSetEventGroupName documentSetId={documentSetId} />
                </Table.Cell>
                <Table.Cell>
                    <DocumentSetEventStartDate documentSetId={documentSetId} />
                </Table.Cell>
                <Table.Cell>
                    <DocumentSetEventEndDate documentSetId={documentSetId} />
                </Table.Cell>
                <Table.Cell
                    style={{
                        paddingTop: 0,
                        paddingBottom: 0
                    }}
                >
                    <DocumentSetProgressBadge documentSetId={documentSetId} />
                </Table.Cell>
                <Table.Cell
                    style={{
                        maxWidth: 200,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    <DocumentSetAssignedUsersList
                        documentSetId={documentSetId}
                    />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <RoleButtonLink
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                            params={{
                                selectedEvent: eventId,
                                generalEventModal: true
                            }}
                        >
                            Edit
                        </RoleButtonLink>
                        <RoleButtonLink
                            requiredRoles={[
                                ADMIN,
                                MANAGER,
                                ASSISTANT_MANAGER,
                                FIELD_STAFF,
                                SUPERVISOR
                            ]}
                            params={{
                                selectedEvent: eventId,
                                generalEventDuplicateModal: true
                            }}
                        >
                            Duplicate
                        </RoleButtonLink>
                        <RoleButtonLink
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                            params={{
                                selectedJobId: documentSetId,
                                deleteJobModal: true
                            }}
                        >
                            Delete
                        </RoleButtonLink>
                        <EventSchemaHasInstructionsGate eventId={eventId}>
                            <EveryoneButtonLink
                                params={{
                                    selectedEvent: eventId,
                                    eventShareModal: true
                                }}
                            >
                                Share
                            </EveryoneButtonLink>
                        </EventSchemaHasInstructionsGate>
                    </TableActions>
                </Table.Cell>
            </RoleTableRowLink>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    eventId: makeSelectDocumentSetValue('eventId')
});

export default connect(mapStateToProps)(DocumentSetsTableRow);
